import { Node } from "./Node.js";
import { ROOT_NODE_ID } from "./constants.js";
const selectedMapper = (registration) => {
  const selected = [];
  for (const value of Object.values(registration))
    value.selected === "selected" && "action" in value.source && selected.push(value.source.id);
  return selected;
}, buildTreeController = (treeBranches) => {
  const regObj = {}, allNodesRecord = {}, rootNode = new Node(
    ROOT_NODE_ID,
    regObj,
    "DEFAULT",
    {},
    selectedMapper
  );
  allNodesRecord[rootNode.id] = rootNode;
  const stack = [
    {
      node: rootNode,
      index: 0,
      children: treeBranches
    }
  ];
  for (; stack.length; ) {
    const item = stack.pop();
    if (item)
      for (let i = item.index; i < item.children.length; i++) {
        const branch = item.children[i], node = item.node.spawn(branch == null ? void 0 : branch.id, branch.label, branch.data);
        if (allNodesRecord[node.id] = node, branch.children) {
          stack.push(
            {
              node: item.node,
              index: ++i,
              children: item.children
            },
            {
              node,
              index: 0,
              children: branch.children
            }
          );
          break;
        }
      }
  }
  return allNodesRecord;
};
export {
  buildTreeController,
  selectedMapper
};
//# sourceMappingURL=buildTreeController.js.map
